import { getAppInstance } from "@/utils/app";
import URI from "urijs";
import { debounce } from "lodash-es";

function _openLogin() {
  const tyApp = getAppInstance();
  //    如果当前是浏览器插件，则打开一个登录页
  if (tyApp) {
    tyApp.nsCall({
      method: "openLogin",
    });
  } else {
    window.open(
      URI("/apps/user_center/login.html")
        .setQuery({
          redirect: "/",
        })
        .toString(),
      "_blank"
    );
  }
}

export const openLogin = debounce(_openLogin, 200);
